module.exports = __webpack_public_path__ + "static/img/1.5ea999e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/1.png
// module id = Mp44
// module chunks = 0